import { Observable } from "rxjs";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";

export class ChatbotRest {
  static host: string = window.location.hostname;
  static env: string = process.env.VUE_APP_WEBSOCKET;
  static wsPrefix: string = this.host == "localhost" ? "ws" : "wss";
  static url: string = `${this.wsPrefix}://${ this.env ??"localhost"}:8020/chatbot`;

  static ws: WebSocketSubject<any> = webSocket({
    url: this.url,
    deserializer: (e) => e.data,
    serializer: (e) => e,
  });

  static wsActions: WebSocketSubject<any> = webSocket({
    url: this.url,
    deserializer: (e) => e.data,
    serializer: (e) => e,
  });

  static websocketChatbot(): Observable<any> {
    return this.ws.asObservable();
  }

  static websocketActions(): Observable<any> {
    return this.wsActions.asObservable();
  }
}
